import './index.less'

import microApp from '@micro-zoe/micro-app'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'

import App from './app'

const lastFaviconProjectId = sessionStorage.getItem('__last_favicon_project_id__');
const faviconKey = lastFaviconProjectId ? `__favicon_url__:${lastFaviconProjectId}` : '__favicon_url__';
const cachedFavicon = sessionStorage.getItem(faviconKey);
if (cachedFavicon) {
  document.querySelectorAll("link[rel*='icon']").forEach((el) => el.parentNode?.removeChild(el));
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = cachedFavicon;
  document.head.appendChild(link);
}

microApp.start({
  iframe: true,
  // 'router-mode': 'native',
})

const container = document.getElementById('root')
const root = createRoot(container!) // createRoot(container!) if you use TypeScript
root.render(
  <Router>
    <App />
  </Router>,
)
